import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
import menu from "./menu.json";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    "@media (max-width:600px)": {
      display: "none",
    },
  },
  ul: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
  },
  li: {
    display: "inline",
    marginRight: 40,
    "&:hover": {
      borderBottom: "2px solid",
      paddingBottom: 3,
    },
    cursor: "pointer",
    "& a": {
      color: "#000",
      textDecoration: "none",
      fontWeight: "600",
    },
  },
});

export default function () {
  const classes = useStyles();

  const menuRenderer = menu.map((m) => (
    <li className={classes.li} key={m.url}>
      <Link to={m.url}>{m.name}</Link>
    </li>
  ));

  return (
    <div className={classes.container}>
      <ul className={classes.ul}>{menuRenderer}</ul>
    </div>
  );
}
